import _ from 'lodash';
import { categoryResult } from '../models/api';

function menuRequest(opts) {
  return {
    type: 'API_REQUEST',
    service: 'MENU',
    ...opts
  };
}

export function getBrands() {
  return menuRequest({
    path: 'brands',
    handleResponse: res => {
      const brands = res.body || [];
      const brandGroups =
        _.groupBy(brands, brand => {
          const init = brand.charAt(0);
          return /[a-z]/i.test(init) ? init : '#';
        }) || {};
      return _.toPairs(brandGroups).map(pair => ({
        key: pair[0],
        brands: pair[1]
      }));
    }
  });
}

export function getBrandProducts(slug, onlyEnabled = false) {
  const name = slug.replace(/-/g, ' ');
  let query = { name };
  if (onlyEnabled) query.enabled = true;

  return menuRequest({
    method: 'POST',
    path: 'brands',
    query: query,
    handleResponse: res => ({
      products: categoryResult(res.body.products, res.headers)
    })
  });
}
